import apiClient from '../apiClient';
import { PUT_TRANSPORTATION_URL } from '../apiUrl';

const putTransportationProfileApi = (id, data) => {
  return apiClient.put(PUT_TRANSPORTATION_URL(id), data);
};

export default putTransportationProfileApi;
